var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 400 272"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bag_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#131927",
  fillOpacity: 0.07,
  d: "M199.54 272c109.651 0 198.54-29.804 198.54-66.571s-88.889-66.57-198.54-66.57S1 168.663 1 205.429C1 242.196 89.89 272 199.54 272"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#AB9777",
  d: "m165.046 45.242 106.779 16.914-46.186 33.389-58.536-20.623-4.942-6.179z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D9CCB9",
  d: "m233.604 230.488 14.727-42.588-8.687-115.442-7.003-.829-7.404 151.311z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2D6C8",
  d: "m233.872 66.27 37.953-4.114 5.347 144.705-32.153-18.961-9.492-115.857z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7C9B6",
  d: "m233.604 230.488 43.568-23.627-32.153-18.961z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C6B198",
  d: "m122.575 56.236 37.928-1.097 1.658 17.733z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B7A182",
  d: "m160.503 55.138 4.544-9.896 2.459 27.63-7.832-4.129z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D0C1AB",
  d: "M122.575 56.236v149.516l111.029 24.736 1.923-158.444z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4A58D",
  d: "M205.805 84.204c-.055 0-.079-.006-.134-.006a1.23 1.23 0 0 1-1.097-1.362c.667-6.977 3.126-13.952 5.534-20.692l1.575-4.443c4.251-11.92 9.544-26.761-1.121-36.408-9.809-8.88-27.129-5.854-37.581 2.05-17.426 13.185-20.58 35.961-20.903 48.372-.028.688-.695 1.148-1.283 1.215a1.274 1.274 0 0 1-1.231-1.283c.347-12.855 3.662-36.481 21.918-50.293 11.466-8.687 29.856-11.774 40.762-1.905 11.896 10.765 6.067 27.137 1.791 39.09l-1.578 4.443c-2.352 6.6-4.757 13.431-5.424 20.098a1.23 1.23 0 0 1-1.231 1.13z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4A58D",
  d: "M239.644 63.478a1.31 1.31 0 0 1-1.283-1.097c-4.543-26.259-13.551-44.459-26.059-52.637-10.022-6.536-18.816-4.464-18.896-4.442-5.293 1.523-8.711 4.448-10.451 8.934-5.933 15.42 11.064 43.23 11.225 43.505a1.284 1.284 0 0 1-.426 1.816 1.327 1.327 0 0 1-1.819-.427c-.723-1.182-17.854-29.193-11.439-45.842 2.032-5.232 6.146-8.778 12.24-10.54.454-.112 10.049-2.364 21.01 4.79 13.337 8.712 22.479 27.015 27.211 54.39a1.3 1.3 0 0 1-1.069 1.523c-.08.012-.162.027-.241.027z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bag_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h400v272H0z"
})))));
export default SvgBag;